const ITEMS = [
  "INTELIGENCIA ARTIFICIAL",
  "AUTOMATIZACIÓN",
  "SOFTWARE",
  "DATA",
  "CIBERSEGURIDAD",
  "CLOUD",
  "TRANSFORMACIÓN DIGITAL",
  "CONSULTORÍA TECNOLÓGICA",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="px-6 text-sm md:text-base font-semibold tracking-[0.25em] text-[var(--muted)]">{item}</span>
        <span className="w-1.5 h-1.5 rounded-full bg-[var(--green)]" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    className="relative overflow-hidden border-y border-[var(--line)] bg-[var(--bg2)] py-5"
    aria-hidden="true"
    data-testid="editorial-marquee"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
